import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BusquedaService {
  private _limpiarBusquedaSource = new BehaviorSubject<void>(null);
  limpiarBusqueda$ = this._limpiarBusquedaSource.asObservable();

  limpiarBusqueda() {
    this._limpiarBusquedaSource.next();
  }
}
